import ActionCable from "actioncable";

/**
 * Converts api value to a human readable value (ie. hourly_no_permit to Hourly: No Permit) 
 * 
 * @param {string} raw_entry_mechanism Accepts raw_entry_mechanism value from API/db (ie. ticket_no_permit)
 * @return {string} Human readable version: (ie. Ticket: No Permit)
 */
const transformEntryMechanism = (raw_entry_mechanism) => {
  if (typeof raw_entry_mechanism === "string") {
    return raw_entry_mechanism.split("_").map( w =>  w.substring(0,1).toUpperCase()+ w.substring(1)).join(" ").replace(" ", ": ");
  } else {
    return "";
  }
}

const getActionCableConsumer = () => {
      // TODO: detect staging for test-siteapp.commutyble.com
    var actionCableUrl = process.env.NODE_ENV === 'production' ? 'wss://siteapp.commutyble.com/cable' : 'ws://localhost:3000/cable'

    return ActionCable.createConsumer(actionCableUrl)
}

const formatRawCredentialString = (credential, credential_type) => {
  console.log("formatRawCredentialString called");
  if (credential_type === "mobile") {
    return "M "+credential;

  } else if (credential_type === "rfid") {
    return credential.replace("C033 ", "");
  } else if (credential_type === "qr") {
    if (credential.startsWith("COMV") || credential.startsWith("COMS")) {
      return "Q "+credential.substring(3,4)+" "+credential.substring(4).replace("-", " ").replace("-", " ");
    }
    else if (credential.startsWith("COMP")) {
      // Remove COMP from QR code and then only a subset of the long string
      // for instance COMP16-67d825f5 -> `P 16 25f5`
      return "Q "+credential.substring(3,4)+" "+credential.substring(4).replace("-", " ").replace(/ \w+(\w{4})/, ' $1')
    }
    else if (credential.startsWith("COM-")) {
      // Remove COM- from QR code and then only shot a subset of the long string
      // for instance COM2a-63cec66a -> `2a 63CE`
      return "Q "+credential.substring(credential.indexOf("-")+1).substring(0, 8).toUpperCase().replace(/^(\w{4})/g, '$1 ');
    }
    else {
      return credential;
    }
  } else if (credential_type === "fob") {
    const identifier = credential.slice(3);
    return `F ${parseInt(identifier, 16)}`;
  } else if (credential_type === "phone") {
    return `P${credential}`;
  } else if (credential_type === "lpr") {
    return `LPR ${credential}`;
  } else {
    return credential;
  }
}

const formatAccessCredential = (transit) => {
  if (transit.mobile_device_id) {
    return formatRawCredentialString(transit.credential , "mobile");
  }
  else if (transit.credential) {
    if (transit.credential.startsWith("C033")) {
      if (transit.count) {
        return formatRawCredentialString(transit.credential+" ("+transit.count+")", "rfid");
      } 
      else {
        return formatRawCredentialString(transit.credential, "rfid");
      }
    } else if (transit.credential.startsWith("COM")) {
      return formatRawCredentialString(transit.credential, "qr");
    } else if (transit.credential.startsWith("+")) {
      return formatRawCredentialString(transit.credential, "phone");
    } else if (/^\d+$/.test(transit.credential)) {
      return formatRawCredentialString(transit.credential, "fob");
    } else {
      return formatRawCredentialString(transit.credential, "lpr");
    }
  } else {
    return "";
  }
};

//  Should be equivalent of Digest::SHA256.hexdigest(string) in Ruby
const digestMessage = async (message) => {
  const msgUint8 = new TextEncoder().encode(message); // encode as (utf-8) Uint8Array
  const hashBuffer = await crypto.subtle.digest("SHA-256", msgUint8); // hash the message
  const hashArray = Array.from(new Uint8Array(hashBuffer)); // convert buffer to byte array
  const hashHex = hashArray.map((b) => b.toString(16).padStart(2, "0")).join(""); // convert bytes to hex string
  return hashHex;
}

export { digestMessage, transformEntryMechanism, formatAccessCredential, formatRawCredentialString, getActionCableConsumer};